import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const KaliteYonetimiPage: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="page-content">
            <h1 className="mb-4 text-center">Kalite Yönetimi</h1>
            <p className="lead text-center">
              Megapark Hastanesi kalite yönetimi bilgileri burada yer alacaktır.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default KaliteYonetimiPage;
